import React from 'react';

import _ from 'lodash';
import appStore from '@stores/app';
import { Tabs } from 'antd';

import GroupsView from 'Content/Groups/GroupsView';
import NewSessionsView from 'Content/Sessions/NewSessionsView';
import { wellbeingConfig, wellbeingMedia } from '@lib/contentConfig';

const { TabPane } = Tabs;

const WellbeingScreen = () => {
    return (
        <Tabs defaultActiveKey={'wellbeingMedia'} animated={false} type="card">
            <TabPane tab={'Wellbeing Media'} key={'wellbeingMedia'}>
                <NewSessionsView {...wellbeingMedia} />
            </TabPane>
            {_.map(wellbeingConfig, group => {
                const tab = (
                    <TabPane tab={group.name} key={group.groupType}>
                        <GroupsView {...group} />
                    </TabPane>
                );
                return group.advanced ? appStore.advancedMode && tab : tab;
            })}
        </Tabs>
    );
};

export { WellbeingScreen };
